import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { ErrorsService } from '../modules/shared/services/errors.service';

// TODO
/**
 * To fix the provided In value
 */
@Injectable()
export class AppRedirectionService implements CanActivate {

  constructor(
    private errorsService: ErrorsService) {
  }

  canActivate(router: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.errorsService.error && router.url[0].path === 'erreur') {
      return true;
    }
  }
}
